var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,7.46069873e-14 C15.5522847,7.46069873e-14 16,0.459191569 16,1.02563307 L16,11.4397195 C16,11.6923345 15.9091024,11.9360637 15.7447288,12.1241934 L12.6564299,15.6588288 C12.2921523,16.0757536 11.6691985,16.1160539 11.2567302,15.7493787 L8,12.8542173 L4.74326983,15.7493787 C4.3308015,16.1160539 3.7078477,16.0757536 3.34357011,15.6588288 L0.2552712,12.1241934 C0.0908976088,11.9360637 -1.24344979e-14,11.6923345 -1.24344979e-14,11.4397195 L-1.0658141e-14,1.02563307 C-1.0658141e-14,0.459191569 0.44771525,7.28306304e-14 1,7.28306304e-14 L15,7.46069873e-14 Z M15,1.02563307 L1,1.02563307 L1,11.4397195 L4.08829891,14.9743549 L7.34502908,12.0791934 C7.69879492,11.7647034 8.21405621,11.746204 8.58682152,12.0236952 L8.65497092,12.0791934 L11.9117011,14.9743549 L15,11.4397195 L15,1.02563307 Z M11.9871835,7.7949354 C12.2704042,7.7949354 12.5,8.02453119 12.5,8.30775194 C12.5,8.59097269 12.2704042,8.82056848 11.9871835,8.82056848 L3.51281654,8.82056848 C3.22959578,8.82056848 3,8.59097269 3,8.30775194 C3,8.02453119 3.22959578,7.7949354 3.51281654,7.7949354 L11.9871835,7.7949354 Z M11.9871835,3.6924031 C12.2704042,3.6924031 12.5,3.92199889 12.5,4.20521964 C12.5,4.48844039 12.2704042,4.71803618 11.9871835,4.71803618 L3.51281654,4.71803618 C3.22959578,4.71803618 3,4.48844039 3,4.20521964 C3,3.92199889 3.22959578,3.6924031 3.51281654,3.6924031 L11.9871835,3.6924031 Z",
    id: "Combined-Shape-Copy-13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.88efd0c1bc7dcf1b6ff22d4e5555cde9.svg";
export { ForwardRef as ReactComponent };